import { ColumnDef } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IReport } from '../../models';

export const createColumns = (): ColumnDef<IReport>[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        accessorKey: 'number',
        header: () => t('account.number'),
      },
      {
        accessorKey: 'access_time',
        header: () => 'Kirish vaqti',
        cell: () => '-',
      },
      {
        accessorKey: 'exit_time',
        header: () => 'Chiqish vaqti',
        cell: () => '-',
      },
      {
        accessorKey: 'farm_name',
        header: () => t('farm.name'),
        cell: () => '-',
      },
      {
        accessorKey: 'stir',
        header: () => t('stir.delivery'),
        cell: () => '-',
      },
      {
        accessorKey: 'place_name',
        header: () => t('place.name'),
      },
      {
        accessorKey: 'cluster',
        header: () => t('claster'),
        cell: () => '-',
      },
      {
        accessorKey: 'organization_stir',
        header: () => t('organization.stir'),
        cell: () => '-',
      },
      {
        accessorKey: 'date',
        header: () => t('date'),
        cell: () => '-',
      },
      {
        accessorKey: 'shipping_letter_number',
        header: () => t('shipping.letter.number'),
        cell: () => '-',
      },
      {
        accessorKey: 'contract_type',
        header: () => t('contract.type'),
      },
      {
        accessorKey: 'transport_type',
        header: () => t('transport.type'),
        cell: () => '-',
      },
      {
        accessorKey: 'transport_number',
        header: () => t('transport.number'),
        cell: () => '-',
      },
      {
        accessorKey: 'crop_type2',
        header: () => t('crop.type2'),
        cell: () => '-',
      },
      {
        accessorKey: 'brutto',
        header: () => t('gross'),
        cell: () => '-',
      },
      {
        accessorKey: 'tara',
        header: () => `${t('tara')} (${t('kg')})`,
        cell: () => '-',
      },
      {
        accessorKey: 'netto',
        header: () => t('netto'),
        cell: () => '-',
      },
      {
        accessorKey: 'pollution',
        header: () => t('pollution3') + '(%)',
      },
      {
        accessorKey: 'humidity',
        header: () => t('humidity') + '(%)',
      },
      {
        accessorKey: 'completeness',
        header: () => t('completeness'),
        cell: () => '-',
      },
      {
        accessorKey: 'cereal_mixture',
        header: () => t('cereal.mixture') + '(%)',
        cell: () => '-',
      },
      {
        accessorKey: 'kleykovina',
        header: () => t('kleykovina'),
        cell: () => '-',
      },
      {
        accessorKey: 'steklovidnost',
        header: () => t('steklovidnost'),
        cell: () => '-',
      },
      {
        accessorKey: 'class',
        header: () => t('class.name'),
      },
      {
        accessorKey: 'konditsion',
        header: () => t('konditsion'),
        cell: () => '-',
      },
      {
        accessorKey: 'seed_generation',
        header: () => t('seed.generation'),
      },
      {
        accessorKey: 'seed_variety',
        header: () => t('seed.variety'),
      },
      {
        accessorKey: 'grain_price',
        header: () => t('grain.price') + ' (so‘m)',
      },
      {
        accessorKey: 'surcharge_price',
        header: () => t('surcharge.price') + ' (so‘m)',
      },
      {
        accessorKey: 'delivery_cost',
        header: () => t('delivery.cost') + ' (so‘m)',
      },
      {
        accessorKey: 'district',
        header: () => t('district'),
      },
      {
        accessorKey: 'region',
        header: () => t('region'),
      },
      {
        accessorKey: 'record_time',
        header: () => t('record.time'),
      },
      {
        accessorKey: 'contract_plan',
        header: () => t('contract.plan'),
      },
      {
        accessorKey: 'delivered_by',
        header: () => t('delivered.by'),
      },
      {
        accessorKey: 'remaining',
        header: () => t('remaining'),
      },
      {
        accessorKey: 'plan_percent',
        header: () => t('plan.percent'),
      },
    ],
    [],
  );
};
